import {
  BaseInfoComponentConfig,
  BaseInfoSectionComponent
} from './common/base-info-section/base-info-section.component';
import {
  ApplicantDataComponentConfig,
  ApplicantDataSectionComponent
} from './common/applicant-data-section/applicant-data-section.component';
import {EntityType} from '../../../pipes/entity-type.pipe';
import {
  TaxObjectDataComponentConfig,
  TaxObjectDataSectionComponent
} from './common/tax-object-data-section/tax-object-data-section.component';
import {Routes} from '@angular/router';
import {
  AttachmentDataComponentConfig,
  AttachmentsDataSectionComponent
} from './common/attachments-data-section/attachments-data-section.component';
import {
  AgreementsDataComponentConfig,
  AgreementsDataSectionComponent
} from './common/agreements-data-section/agreements-data-section.component';
import {SessionService} from '../../../services/ssession.service';

export const desktopStages: string[] = [
  'Informacje podstawowe',
  'Dane identyfikacyjne',
  'Przedmiot opodatkowania',
  'Zgody',
  'Załączniki'
];

export const mobileStages: string[] = [
  'Informacje podstawowe',
  'Dane identyfikacyjne',
  'Przedmiot opodatkowania',
  'Zgody',
  'Załączniki'
];

export const stages: string[] = SessionService.GetUISettings()?.mobileEmbed ? mobileStages : desktopStages;

export const baseInfoSectionConfig: BaseInfoComponentConfig = {
  stages,
  successUrl: 'dane-identyfikacyjne',
  submissionPurposeOptions: [
    'Deklaracja składana w terminie do dnia 15 lutego roku podatkowego',
    'Powstanie obowiązku podatkowego w trakcie roku podatkowego',
    'Wygaśnięcie obowiązku podatkowego',
    'Zmiana miejsca zamieszkania lub siedziby',
    'Korekta deklaracji',
    'Przedłużenie okresu czasowego wycofania pojazdu z ruchu'
  ],
  entityKindOptions: [
    'Właściciel',
    'Współwłaściciel wpisany jako pierwszy w dowodzie rejestracyjnym',
    'Współwłaściciel niewpisany jako pierwszy w dowodzie rejestracyjnym'
  ]
};

export const applicantDataSectionConfig: ApplicantDataComponentConfig = {
  stages,
  entityType: EntityType.OSOBA_PRAWNA,
  successUrl: '../przedmiot-opodatkowania',
  cancelUrl: '../informacje-podstawowe'
};

export const taxObjectDataSectionConfig: TaxObjectDataComponentConfig = {
  stages,
  successUrl: '../zgody',
  cancelUrl: '../dane-identyfikacyjne',
  forceNext: true,
  removeIsPartOfNatureReserveControl: true,
  removeIsTaxExemptControl: true,
  removeAreaHaControl: true,
  customTitles: {
    noDataInfo: 'Brak dodanych środków transportu!',
    cardTitle: 'Dodanie środku transportu',
    cardTitle2: 'Edycja środku transportu',
    addBtnTitle: 'Dodaj środek transportu',
    addBtn2Title: 'Dodaj kolejny środek transportu'
  }
};

export const agreementsDataSectionConfig: AgreementsDataComponentConfig = {
  stages,
  cancelUrl: '../przedmiot-opodatkowania',
  successUrl: '../zalaczniki'
};

export const attachmentDataSectionConfig: AttachmentDataComponentConfig = {
  stages,
  cancelUrl: '../zgody'
};

export const meansOfTransportTaxDt1DesktopRoutes: Routes = [
  {
    path: 'informacje-podstawowe',
    component: BaseInfoSectionComponent,
    data: baseInfoSectionConfig
  },
  {
    path: ':appId/informacje-podstawowe',
    component: BaseInfoSectionComponent,
    data: baseInfoSectionConfig
  },
  {
    path: ':appId/dane-identyfikacyjne',
    component: ApplicantDataSectionComponent,
    data: applicantDataSectionConfig
  },
  {
    path: ':appId/przedmiot-opodatkowania',
    component: TaxObjectDataSectionComponent,
    data: taxObjectDataSectionConfig
  },
  {
    path: ':appId/zgody',
    component: AgreementsDataSectionComponent,
    data: agreementsDataSectionConfig
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  {path: '', redirectTo: 'informacje-podstawowe', pathMatch: 'prefix'}
];

export const meansOfTransportTaxDt1MobileRoutes: Routes = [
  {
    path: 'informacje-podstawowe',
    component: BaseInfoSectionComponent,
    data: baseInfoSectionConfig
  },
  {
    path: ':appId/informacje-podstawowe',
    component: BaseInfoSectionComponent,
    data: baseInfoSectionConfig
  },
  {
    path: ':appId/dane-identyfikacyjne',
    component: ApplicantDataSectionComponent,
    data: applicantDataSectionConfig
  },
  {
    path: ':appId/przedmiot-opodatkowania',
    component: TaxObjectDataSectionComponent,
    data: taxObjectDataSectionConfig
  },
  {
    path: ':appId/zgody',
    component: AgreementsDataSectionComponent,
    data: {
      ...agreementsDataSectionConfig,
      removeRegulationsControl: true
    }
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  {path: '', redirectTo: 'informacje-podstawowe', pathMatch: 'prefix'}
];

export const meansOfTransportTaxDt1Routes: Routes = SessionService?.GetUISettings()?.mobileEmbed ? meansOfTransportTaxDt1MobileRoutes : meansOfTransportTaxDt1DesktopRoutes;
